/* Bundle Builder runtime. Locked from variant A prototype.
   Ref: specs/2026-05-batch/bundle-builder-prototypes/a-compact.html
   Spec: specs/2026-05-batch/bundle-builder-design.md
*/
(function () {
  'use strict';

  const section = document.querySelector('[data-bundle-section]');
  if (!section) return;

  const tierStrip = section.querySelector('[data-tier-strip]');
  const componentGrid = section.querySelector('[data-component-grid]');
  const progressEl = section.querySelector('[data-progress]');
  const slotsEl = section.querySelector('[data-slots]');
  const cta = section.querySelector('[data-cta]');
  const ctaLabel = section.querySelector('[data-cta-label]');
  const ctaTotal = section.querySelector('[data-cta-total]');
  const summaryEl = section.querySelector('[data-bundle-summary]');
  const slotPanel = section.querySelector('[data-slot-panel]');
  const progressRing = section.querySelector('[data-progress-ring]');

  if (!tierStrip || !componentGrid || !cta) return;

  const ctaIdleLabel = section.dataset.ctaLabel || 'Add box to cart';
  const tierSuffix = section.dataset.tierSuffix || 'pieces';

  const currency =
    document.querySelector('meta[property="og:price:currency"]')?.content ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    'GBP';
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  function money(cents) {
    return formatter.format((cents || 0) / 100);
  }

  const state = {
    activeTierId: null,
    activeTierQty: 0,
    activeTierPriceCents: 0,
    activeTierCompareCents: 0,
    counts: new Map(),   // componentId -> { count, title, image }
    order: [],            // componentId per slot, in submission order (LIFO trim)
  };

  function totalCount() { return state.order.length; }

  function ensureCounts(id, card) {
    if (!state.counts.has(id)) {
      state.counts.set(id, {
        count: 0,
        title: card.dataset.componentTitle,
        image: card.dataset.componentImage || '',
      });
    }
    return state.counts.get(id);
  }

  function add(id, card) {
    if (totalCount() >= state.activeTierQty) return;
    const c = ensureCounts(id, card);
    c.count++;
    state.order.push(id);
    render();
  }

  function remove(id) {
    if (!state.counts.has(id)) return;
    const c = state.counts.get(id);
    if (c.count === 0) return;
    c.count--;
    for (let i = state.order.length - 1; i >= 0; i--) {
      if (state.order[i] === id) { state.order.splice(i, 1); break; }
    }
    if (c.count === 0) state.counts.delete(id);
    render();
  }

  function removeAtSlotIndex(idx) {
    if (idx < 0 || idx >= state.order.length) return;
    const id = state.order[idx];
    state.order.splice(idx, 1);
    const c = state.counts.get(id);
    c.count--;
    if (c.count === 0) state.counts.delete(id);
    render();
  }

  function reset() {
    state.counts.clear();
    state.order.length = 0;
    render();
  }

  function setTier(card) {
    state.activeTierId = card.dataset.tierId;
    state.activeTierQty = parseInt(card.dataset.tierQty, 10) || 0;
    state.activeTierPriceCents = parseInt(card.dataset.tierPrice, 10) || 0;
    state.activeTierCompareCents = parseInt(card.dataset.tierCompare, 10) || 0;
    tierStrip.querySelectorAll('.tier-card').forEach(el => {
      el.classList.toggle('is-active', el === card);
    });
    while (totalCount() > state.activeTierQty) {
      let topId = null, topCount = 0;
      for (const [id, c] of state.counts) {
        if (c.count > topCount) { topCount = c.count; topId = id; }
      }
      if (!topId) break;
      for (let i = state.order.length - 1; i >= 0; i--) {
        if (state.order[i] === topId) { state.order.splice(i, 1); break; }
      }
      const c = state.counts.get(topId);
      c.count--;
      if (c.count === 0) state.counts.delete(topId);
    }
    render();
  }

  function render() {
    const total = totalCount();
    const remaining = state.activeTierQty - total;
    const complete = state.activeTierQty > 0 && remaining === 0;

    if (progressRing) {
      const pct = state.activeTierQty > 0
        ? Math.min(100, (total / state.activeTierQty) * 100)
        : 0;
      progressRing.style.setProperty('--p', pct);
    }

    const limitReached = remaining === 0;
    componentGrid.querySelectorAll('[data-component-card]').forEach(card => {
      if (card.classList.contains('is-sold-out')) return;
      const id = card.dataset.componentId;
      const count = state.counts.get(id)?.count || 0;
      const actions = card.querySelector('[data-actions]');

      if (count > 0) {
        actions.innerHTML =
          '<div class="qty-stepper">' +
          '<button type="button" data-action="dec" aria-label="Remove one">−</button>' +
          '<span class="count">' + count + '</span>' +
          '<button type="button" data-action="inc" aria-label="Add one"' + (limitReached ? ' disabled' : '') + '>+</button>' +
          '</div>';
      } else {
        actions.innerHTML =
          '<button type="button" class="btn-add" data-action="inc"' + (limitReached ? ' disabled' : '') + '>' +
          (limitReached ? 'Box is full' : 'Add') +
          '</button>';
      }

      const img = card.querySelector('.component-image');
      let badge = img.querySelector('.badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'badge';
          img.prepend(badge);
        }
        badge.textContent = count + ' in box';
        card.classList.add('is-in-bundle');
      } else {
        if (badge) badge.remove();
        card.classList.remove('is-in-bundle');
      }
    });

    let slotHtml = '';
    state.order.forEach((id, idx) => {
      const info = state.counts.get(id);
      const title = info.title;
      const image = info.image;
      const initial = (title || '?').replace(/^Gluten Free\s+/i, '').slice(0, 1).toUpperCase();
      const bg = image ? ' style="background-image:url(\'' + escapeAttr(image) + '\')"' : '';
      slotHtml +=
        '<button type="button" class="slot is-filled' + (image ? ' has-image' : '') + '" data-slot-index="' + idx + '"' + bg + ' ' +
        'title="' + escapeAttr(title) + ' — click to remove" aria-label="Remove ' + escapeAttr(title) + '">' +
        (image ? '' : '<span class="filled-initial">' + initial + '</span>') +
        '</button>';
    });
    for (let i = 0; i < Math.max(remaining, 0); i++) {
      slotHtml += '<span class="slot" aria-hidden="true"></span>';
    }
    slotsEl.innerHTML = slotHtml;

    if (complete) {
      progressEl.classList.add('is-complete');
      progressEl.textContent = 'Your ' + state.activeTierQty + '-piece box is ready';
      cta.disabled = false;
      ctaLabel.textContent = ctaIdleLabel;
    } else {
      progressEl.classList.remove('is-complete');
      progressEl.innerHTML =
        '<strong>' + total + '</strong> of ' + state.activeTierQty + ' ' + escapeHtml(tierSuffix) + ' chosen';
      cta.disabled = true;
      ctaLabel.textContent = remaining > 0 ? 'Add ' + remaining + ' more to complete' : ctaIdleLabel;
    }
    if (state.activeTierCompareCents > state.activeTierPriceCents) {
      ctaTotal.innerHTML =
        '<s class="cta-compare">' + escapeHtml(money(state.activeTierCompareCents)) + '</s>' +
        '<span class="cta-now">' + escapeHtml(money(state.activeTierPriceCents)) + '</span>';
    } else {
      ctaTotal.textContent = money(state.activeTierPriceCents);
    }
  }

  async function submit() {
    if (cta.disabled) return;
    const properties = {};
    let idx = 1;
    for (const [, info] of state.counts) {
      if (info.count > 0) properties[idx++] = info.count + 'x ' + info.title;
    }
    cta.disabled = true;
    cta.classList.add('is-loading');
    const labelBefore = ctaLabel.textContent;
    ctaLabel.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(state.activeTierId, 10),
            quantity: 1,
            properties: properties,
          }],
        }),
      });
      if (!res.ok) throw new Error('add to cart failed: ' + res.status);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      reset();
    } catch (err) {
      console.error('[bundle] add to cart failed', err);
      ctaLabel.textContent = 'Try again';
      cta.disabled = false;
    } finally {
      cta.classList.remove('is-loading');
      if (cta.disabled === false && ctaLabel.textContent === 'Adding…') {
        ctaLabel.textContent = labelBefore;
      }
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>]/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[ch]));
  }
  function escapeAttr(s) {
    return String(s).replace(/["&<>]/g, ch => ({ '"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;' }[ch]));
  }

  function init() {
    const firstTier = tierStrip.querySelector('.tier-card');
    if (firstTier) setTier(firstTier);

    tierStrip.addEventListener('click', e => {
      const card = e.target.closest('.tier-card');
      if (card) setTier(card);
    });

    componentGrid.addEventListener('click', e => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const card = btn.closest('[data-component-card]');
      if (!card) return;
      const id = card.dataset.componentId;
      if (btn.dataset.action === 'inc') add(id, card);
      else if (btn.dataset.action === 'dec') remove(id);
    });

    slotsEl.addEventListener('click', e => {
      const slot = e.target.closest('.slot.is-filled');
      if (!slot) return;
      removeAtSlotIndex(parseInt(slot.dataset.slotIndex, 10));
    });

    if (summaryEl && slotPanel) {
      const togglePanel = () => {
        const open = summaryEl.getAttribute('aria-expanded') === 'true';
        const next = !open;
        summaryEl.setAttribute('aria-expanded', next ? 'true' : 'false');
        summaryEl.classList.toggle('is-open', next);
        slotPanel.classList.toggle('is-open', next);
        if (next) slotPanel.removeAttribute('hidden');
        else slotPanel.setAttribute('hidden', '');
      };
      summaryEl.addEventListener('click', togglePanel);
      summaryEl.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          togglePanel();
        }
      });
    }

    cta.addEventListener('click', submit);

    const veganToggle = section.querySelector('[data-vegan-toggle]');
    if (veganToggle) {
      veganToggle.addEventListener('change', () => {
        componentGrid.classList.toggle('is-veg-only', veganToggle.checked);
      });
    }

    const modal = section.querySelector('[data-bundle-modal]');
    const modalContent = modal && modal.querySelector('[data-modal-content]');
    if (modal && modalContent) {
      const wireCarousel = () => {
        const carousel = modalContent.querySelector('[data-modal-carousel]');
        if (!carousel) return;
        const track = carousel.querySelector('[data-modal-slides]');
        if (!track) return;
        const original = Array.from(track.querySelectorAll('.bundle-modal-slide'));
        const total = original.length;
        if (total < 2) return;

        const firstClone = original[0].cloneNode(true);
        firstClone.setAttribute('data-clone', '');
        const lastClone = original[total - 1].cloneNode(true);
        lastClone.setAttribute('data-clone', '');
        track.appendChild(firstClone);
        track.prepend(lastClone);

        const dots = modalContent.querySelectorAll('[data-modal-dots] .bundle-modal-dot');

        const jump = (domIdx) => {
          track.scrollLeft = domIdx * track.clientWidth;
        };
        const goTo = (domIdx) => {
          track.scrollTo({ left: domIdx * track.clientWidth, behavior: 'smooth' });
        };
        const currentDom = () => Math.round(track.scrollLeft / track.clientWidth);

        requestAnimationFrame(() => jump(1));

        const prev = carousel.querySelector('[data-modal-prev]');
        const next = carousel.querySelector('[data-modal-next]');
        if (prev) prev.addEventListener('click', () => goTo(currentDom() - 1));
        if (next) next.addEventListener('click', () => goTo(currentDom() + 1));

        let snapTimer;
        track.addEventListener('scroll', () => {
          const c = currentDom();
          let realIdx;
          if (c <= 0) realIdx = total - 1;
          else if (c >= total + 1) realIdx = 0;
          else realIdx = c - 1;
          dots.forEach((d, n) => d.classList.toggle('is-active', n === realIdx));

          clearTimeout(snapTimer);
          snapTimer = setTimeout(() => {
            const cur = currentDom();
            if (cur <= 0) jump(total);
            else if (cur >= total + 1) jump(1);
          }, 220);
        });
      };
      const openModal = (card) => {
        const tpl = card.querySelector('template[data-component-details]');
        if (!tpl) return;
        modalContent.innerHTML = '';
        modalContent.appendChild(tpl.content.cloneNode(true));
        modal.removeAttribute('hidden');
        document.body.classList.add('bundle-modal-open');
        wireCarousel();
        const closeBtn = modal.querySelector('.bundle-modal-close');
        if (closeBtn) closeBtn.focus();
      };
      const closeModal = () => {
        modal.setAttribute('hidden', '');
        modalContent.innerHTML = '';
        document.body.classList.remove('bundle-modal-open');
      };
      componentGrid.addEventListener('click', e => {
        const btn = e.target.closest('[data-component-info]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        const card = btn.closest('[data-component-card]');
        if (card) openModal(card);
      });
      modal.addEventListener('click', e => {
        if (e.target.closest('[data-modal-close]')) closeModal();
      });
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
